import { jsx as _jsx } from "react/jsx-runtime";
import { MyMealsMenuOptions } from "./MyMealsMenuOptions";
import { MyMealsMenuSkeletonOptions } from "../utils/MyMealsMenuSkeletonOptions";
import { MyMealsNavBarMenu } from "../NavBarComponents/MyMealsNavBarMenu";
import { MyMealsNavDrawerMenu } from "../NavDrawerComponents/MyMealsNavDrawerMenu";
export const MyMealsMenuComponent = ({ M, isNavDrawer }) => {
    const MENU_COMPONENT = isNavDrawer ? MyMealsNavDrawerMenu : MyMealsNavBarMenu;
    const OPTIONS_COMPONENT = M.loading ? MyMealsMenuSkeletonOptions : MyMealsMenuOptions;
    return (_jsx(MENU_COMPONENT, Object.assign({ M: M }, { children: _jsx(OPTIONS_COMPONENT, { orders: M.orders, handleClose: M.handleClose, isNavDrawer: isNavDrawer }) })));
};
